import { SidePanel } from "@wix/design-system";
import classNames from "classnames";
import React from "react";
import { UiComponentsProvider } from "../../ui-components-provider";
import { ROOT } from "./data-hooks";
import classes from "./side-panel-desktop-layout-scss";
const SidePanelDesktopLayout = ({
  onCloseButtonClick,
  dataHook,
  header,
  content,
  footer,
  sidePanelProps
}) => {
  return /* @__PURE__ */ React.createElement(UiComponentsProvider, null, /* @__PURE__ */ React.createElement(
    SidePanel,
    {
      onCloseButtonClick,
      height: "100vh",
      dataHook: classNames(ROOT, dataHook),
      ...sidePanelProps
    },
    header && /* @__PURE__ */ React.createElement(SidePanel.Header, { showDivider: true, ...header }),
    /* @__PURE__ */ React.createElement(SidePanel.Content, { stretchVertically: true, ...content }),
    footer && /* @__PURE__ */ React.createElement(SidePanel.Footer, { showDivider: true, className: classes.footer, ...footer })
  ));
};
export {
  SidePanelDesktopLayout
};
//# sourceMappingURL=side-panel-desktop-layout.js.map
